<template>
  <div class="progress">
    <div class="progress-outer">
      <div class="progress-inner" :style="{ width: getWidth + '%',background: getBackgroundColor }"><span>{{ value }}</span></div>
    </div>
    <span class="progress-text">{{ total }}</span>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    total: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: '#52c41a'
    },
    strokeColor: {
      type: Array,
      default: () => {

      }
    }
  },
  data () {
    return {}
  },
  computed: {
    getWidth () {
      if (this.$props.value / this.$props.total * 100 < 100) {
        return this.$props.value / this.$props.total * 100
      } else {
        return 100
      }
    },
    // 获取 进度条颜色对象
    getBackgroundColor () {
      const { strokeColor } = this.$props
      if (strokeColor) {
        let gradientColor = ''
        for (let i = 0; i <= strokeColor.length - 1; i++) {
          if (strokeColor.length - 1 === i) {
            gradientColor += strokeColor[i]
          } else {
            gradientColor += strokeColor[i] + ','
          }
        }
        return 'linear-gradient(to right,' + gradientColor + ')'
      } else {
        return this.$props.color
      }
    }
  }
}
</script>

<style lang="less">
  .progress {
    display: flex;
    align-items: center;
    .progress-outer {
      height: 20px;
      position: relative;
      display: inline-block;
      vertical-align: middle;
      background-color: #f7f7f7;
      flex: 1 1 30px;
      .progress-inner {
        text-align: center;
        color: #4a4a4a;
        height: 100%;
      }
    }
    .progress-text {
      width: 30px;
      margin-left: 8px;
    }
  }
</style>
